import { render, staticRenderFns } from "./VisaDirectRecipient.vue?vue&type=template&id=9f4d4976&scoped=true&"
import script from "./VisaDirectRecipient.vue?vue&type=script&lang=js&"
export * from "./VisaDirectRecipient.vue?vue&type=script&lang=js&"
import style0 from "./VisaDirectRecipient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VisaDirectRecipient.vue?vue&type=style&index=1&id=9f4d4976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4d4976",
  null
  
)

export default component.exports